<template>
  <v-container class="ma-0 pa-0">
    <!-- :style="`background-color:${v.colour}`" -->

    <img class="ma-0 pa-0" :key=v.id v-for="v in values" width="32px;" height="32px;" :src=v.path />
  </v-container>
</template>
 
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class FaceRating extends Vue {

    @Prop() public value!: string;

    public async mounted() {
        return;
    }

    get values() {
      const self = this;
      const vals = this.value.split(';');
      vals.pop();
      const tmp = vals.map((s, i) => ( {id: i, path: require('@/assets/' + s + '.svg'), colour: self.get_colour(s)}) );
      return tmp;
    }

    private get_colour(val: string) {
      if (val === 'happy') {
        return 'green';
      } else if (val === 'unamused') {
        return 'yellow';
      } else {
        return 'red';
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>